<template>
    <div>
        <slot :months="months" :opendialog="opendialog"></slot>
    </div>
</template>

<script>
import { groupBy, map } from 'lodash';
import { format, isSameYear } from 'date-fns';
import { ref, defineComponent, watch } from 'vue';

export default defineComponent({
    name: 'CalendarList',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        opendialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const months = ref([]);
        const openDialog = ref(null);

        const computeMonths = (items) => {
            if (!items.length) return;

            const groupedDays = groupBy(items, item => item._auxiliary.group_by_day);

            const processedDays = map(groupedDays, (items, key) => ({
                id: `day-${key}`,
                day: format(items[0].performancedate, 'EEE'),
                date: isSameYear(items[0].performancedate, new Date())
                    ? format(items[0].performancedate, 'MMM d')
                    : format(items[0].performancedate, 'MMM d, yyyy'),
                events: items,
                _auxiliary: items[0]._auxiliary,
            }));

            const groupedMonths = groupBy(processedDays, item => item._auxiliary.group_by_month);

            months.value = map(groupedMonths, (items, key) => ({
                id: `month-${key}`,
                title: items[0]._auxiliary.group_name_month,
                days: items,
            }));
        };

        watch(
            [() => props.items, () => props.opendialog],
            ([newItems, newOpenDialog]) => {
                computeMonths(newItems);
                openDialog.value = newOpenDialog;
            },
            { immediate: true }
        );

        return {
            months,
            opendialog: openDialog,
        };
    },
});
</script>
